import React, { useState } from 'react'
import Select from 'react-select';
import { RegaliaUxDialog, RegaliaUxConstants } from '../../components/regalia-ux';
import { useGetRegaliaUxDialogData } from '../../hooks/useGetRegaliaUxDialogData';
import { useGetCustomerNameListSettings } from '../../components/regalia-ux/hooks';
import { gaPackageBrowseFilterSelection } from "../../util/googleAnalytics";

export const FilterColCatalogComponent = ({
	catalog,
    collections: collectionsProp,
	selectedCollection,
	setSelectedCollection,
	degrees,
	selectedDegree,
	setSelectedDegree,
}) => {

    const [isRegaliaDialogVisible, setIsRegaliaDialogVisible] = useState(true);
    const [curCatalogOsr, setCurCatalogOsr] = useState(null);

    const collections = curCatalogOsr ? collectionsProp.filter(cur => cur.catalogKey.includes(curCatalogOsr)) : collectionsProp
    
    const { customerNameListSettings } = useGetCustomerNameListSettings()
    const isStudentVerificationAvailable = customerNameListSettings && customerNameListSettings.length > 0
    const isRegaliaUX = catalog[RegaliaUxConstants.FEATURE_FLAG_NAME] || isStudentVerificationAvailable
    const regaliaUxDialogData = useGetRegaliaUxDialogData(catalog)

    const onSelectCatalogReagliaUX = ({value}) => { 
        let selectedCatalogKey
        Object.keys(catalog.subCatalogs).forEach(catalogKey => {
            if (!selectedCatalogKey && catalog.subCatalogs[catalogKey].publishedCatalogId === value) {
                selectedCatalogKey = catalogKey
            }
        })
        
        const catalogOsr = selectedCatalogKey?.split("-")[1];
        setCurCatalogOsr(catalogOsr)

        const selectedCollection = collections.find(catalog => catalog.catalogKey === selectedCatalogKey)
        gaPackageBrowseFilterSelection("COLGradPackageSelectYourCollection", selectedCollection.label)
        setSelectedCollection(selectedCollection);
    }
    const onSelectDegreeReagliaUX = (val) => { console.log(val)}

    const showDropdownCollectionFilter = collections?.length > 1 || degrees?.length > 1

	
	return (
        <>
            {isRegaliaUX && (
                <RegaliaUxDialog 
                    isVisible={isRegaliaDialogVisible} 
                    data={regaliaUxDialogData} 
                    onHide={()=>setIsRegaliaDialogVisible(false)}
                    onSelectCatalog={onSelectCatalogReagliaUX}
                    onSelectDegree={onSelectDegreeReagliaUX}
                />
            )}
            {showDropdownCollectionFilter && (
                <div className='row container-fluid mb-3'>
                <div
                    className={`col-lg-5 col-md-6 col-sm-12 ${selectedCollection &&
                        Object.keys(selectedCollection)?.length > 0
                        ? ''
                        : 'highlight-border'
                        }`}>
                    <label>Select a collection from the drop down to see results</label>
                    <Select
                        defaultValue={
                            selectedCollection &&
                                Object.keys(selectedCollection)?.length > 0
                                ? selectedCollection
                                : { label: 'Select Your Collection', value: '' }
                        }
                        onChange={(obj) => {
                            gaPackageBrowseFilterSelection("COLGradPackageSelectYourCollection", obj.label)
                            setSelectedCollection(obj);
                        }}
                        options={collections}
                    />
                </div>
                {degrees.length > 1 && (
                    <div
                        className={`col-lg-5 col-md-6 col-sm-12 ${selectedDegree &&
                            Object.keys(selectedDegree)?.length > 0
                            ? ''
                            : 'highlight-border'
                            }`}>
                        <label>Select a degree from dropdown to see results</label>
                        <Select
                            defaultValue={
                                selectedDegree &&
                                    Object.keys(selectedDegree)?.length > 0
                                    ? selectedDegree
                                    : { label: 'Select Your Degree', value: '' }
                            }
                            onChange={(obj) => {
                                gaPackageBrowseFilterSelection("COLGradPackageSelectDegree", obj?.label)
                                setSelectedDegree(obj);
                            }}
                            options={degrees}
                        />
                    </div>
                )}
                </div>
            )}
        </>
    )
    
}

export default FilterColCatalogComponent